import {
    AccessDeniedError,
    BadRequestError,
    ConnectionError,
    HttpTypes,
    InternalServerError,
    TooManyRequestsError,
    UnexpectedError,
} from 'src/http';
import { HttpError } from 'src/http/errors/http-error';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { HttpDto } from 'src/types/common/http-dto';
import { Either } from 'src/utils/either';

export class PromotionsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async create(body: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `promotions/create`,
      body,
    };
    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPromotions(
    params?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined | HttpDto.PaginationResponse<any>
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `promotions/findAll`,
      params,
    };
    const response = await this.api.request(request);
    return httpResponseHandler<HttpDto.PaginationResponse<any>>(response);
  }

  async changeStatus(
    id: string
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `promotions/changeStatus/${id}`,
    };

    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async uploadImage(body?: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `media/upload/base64/promotions`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async update(id: string, body: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `promotions/update/${id}`,
      body,
    };

    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async delete(id: string): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: `promotions/delete/${id}`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async getConfig(): Promise<Either<HttpError, { checkCurrentPromotions: boolean; hasActivePromotions: boolean } | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `promotions/config`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async updateConfig(body: { checkCurrentPromotions: boolean }): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `promotions/config`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
